import { reactive, readonly, watch, ref } from 'vue';
//classe store con function di utilizzo base da cui derivare altri store
export class Store {
    constructor(storeName) {
        this.storeName = storeName;
        let data = this.data();
        this.state = reactive(data);
    }
    getState() {
        return readonly(this.state);
    }
}
export class PersistentStore extends Store {
    constructor(storeName) {
        super(storeName);
        this.storeName = storeName;
        this.isInitialized = ref(false);
    }
    async init() {
        if (this.isInitialized) {
            let stateFromIndexedDB = localStorage.getItem(this.storeName);
            if (stateFromIndexedDB) {
                Object.assign(this.state, JSON.parse(stateFromIndexedDB));
            }
            watch(() => this.state, (val) =>  localStorage.setItem(this.storeName, JSON.stringify(val)), { deep: true });
            this.isInitialized.value = true;
        }

    }
    closeStore(){
        localStorage.removeItem(this.storeName)
        this.isInitialized.value=false
    }
    getIsInitialized() {
        return this.isInitialized;
    }
}


//# sourceMappingURL=main.js.map
